import { cn } from 'noddi-ui-common';

export const webButtonStyling = cn(
  'rounded-md transition-all focus-visible:ring-3 focus-visible:ring-ring focus-visible:outline-hidden disabled:pointer-events-none aria-invalid:border-destructive aria-invalid:ring-destructive/20 [&:not(:disabled)]:active:scale-90'
);
